import Vue from 'vue'
import Vuex from 'vuex'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'


Vue.use(Vuex)

function getfileSize(progressSize) {
	if (progressSize < 1024) {
		//小于0.1KB，则转化成B
		progressSize = progressSize.toFixed(2) + "B";
	} else if (progressSize < 1024 * 1024) {
		// 小于0.1MB，则转化成KB
		progressSize = (progressSize / 1024).toFixed(2) + "KB";
	} else if (progressSize < 1024 * 1024 * 1024) {
		// 小于0.1GB，则转化成MB
		progressSize = (progressSize / (1024 * 1024)).toFixed(2) + "MB";
	} else {
		// 其他转化成GB
		progressSize = (progressSize / (1024 * 1024 * 1024)).toFixed(2) + "GB";
	}

	return progressSize;
}

const store = new Vuex.Store({
	state: {
		jxcSystemPermission: {
			AdminRole: () => { 
				return sessionStorage.getItem('userRoleId') === '1'  // 1: 超级管理员(admin)
				|| sessionStorage.getItem('userRoleId') === '48'  // 48: 行政总监
				|| sessionStorage.getItem('userRoleId') === '31'  // 31: 行政人员
			}, 
			buyRequestCreate: () => { return sessionStorage.getItem('uid') === '96' || sessionStorage.getItem('userRoleId') === '1' }, // 申领单夹带请购单创建权限（陈总 uid=96 / admin roleId=1）
		}, // 进销存系统权限
		goodsSystem: sessionStorage.getItem('userRoleId') == 28 ? 0 : 1, // 0 商务进销存, 1 行政进销存
		chatDialogVisible: sessionStorage.getItem('chatDialogVisible'),
		progress: null, // 文件下载进度列表
		routes: [],
		currentUser: JSON.parse(window.sessionStorage.getItem('user')),
		stomp: null,
		serviceName: {
			// 登录
			login: 'auth-server',
			// 项目管理报表
			manageReport: 'project-manage-report-service',
			// 项目文档管理
			manageArchive: 'project-manage-archive-service',
			// 字典
			managementService: '/work',
			// 商机管理
			marketingManagement: "customer-marketing-management-service",
			// 客户信息
			infogManagement: "customer-info-management-service",
			// 部门成本管理
			manageCost: "depart-manage-cost-service",
			// 需求信息管理页面
			infoManage: 'demand-info-manage-service',
			// 工单系统
			workOrder: '/work',
			// 车辆管理
			borrowCar: '/work',
			// 客户营销
			marketing: '/work',
			// 进销存系统
			goodsSystem: '/work/jxc',
			// 年度提成
			commission: '/work/year',
			// 屏幕管理
			screen: '/work',
			// 流程中心(可视化审批)
			wflow: '/work',
		},
		IPAss: {
			// 接口地址
			TP: process.env.VUE_APP_BASE_API,
			// 文件预览
			yl: process.env.VUE_APP_PREVIEW_FILE_URL,

		}
	},


	mutations: {
		switchChatDialogtip(state, bol) {
			state.chatDialogVisible = bol;
		},
		INIT_USER(state, user) {  //提供方法存入user信息； main.js写入user信息
			state.currentUser = user;
		},
		initRoutes(state, data) {
			state.routes = data;
		},
		SET_PROGRESS: (state, progressObj) => {
			// 修改进度列表
			state.progress = getfileSize(progressObj.progress)
			//console.log(state.progress)
		},
	},

	actions: {
	}

})

export default store;
